import moment from "moment-timezone";

import { useLocationDocument } from "../../api/firestoreWrappers.generated";

const TimeDisplay = ({
    timestamp,
    format,
    hideDateIfToday,
    breakOnHashtag,
    organizationId,
    locationId,
    location: providedLocation,
}) => {
    // When a location is already provided, we pass undefined to our hook which disables it effectively
    const [localLocation] = useLocationDocument(
        providedLocation ? undefined : organizationId,
        providedLocation ? undefined : locationId,
    );

    // Prefer our providedLocation over our localLocation
    const location = providedLocation ?? localLocation;

    const formatTimestamp = (timezone, breakOnHashtag) => {
        const dateMoment = moment(timestamp * 1000).tz(timezone);
        const isToday = dateMoment.isSame(moment().tz(timezone), "day");
        let displayFormat =
            isToday && hideDateIfToday
                ? format.replace(/\b(YYYY|MM|DD|ddd|dddd)\b[-\s]*/g, "")
                : format;
        if (breakOnHashtag && displayFormat.includes("#")) {
            displayFormat = displayFormat.replace("#", "<br />");
        } else {
            displayFormat = displayFormat.replace("#", " ");
        }
        return dateMoment.format(displayFormat);
    };

    const userTimezone = moment.tz.guess();
    const localTimezone = location?.timezone || "UTC";
    const isDifferentTimezone = userTimezone !== localTimezone;
    const titleText = isDifferentTimezone
        ? `Local Time (${localTimezone}): ${formatTimestamp(localTimezone, false)}`
        : "";

    return (
        <span title={titleText}>
            <span
                // biome-ignore lint/security/noDangerouslySetInnerHtml: Timestamp formatting uses controlled HTML to insert a line break.
                dangerouslySetInnerHTML={{
                    __html: formatTimestamp(userTimezone, breakOnHashtag),
                }}
            />
        </span>
    );
};

export default TimeDisplay;
